import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Contact from '../components/Contact/Contact'
import Footer from '../components/Footer/Footer'
import Contacthero from '../components/Contact/Contacthero'

const Contactpage = () => {
    return (
        <div>
        <Navbar/>
        <Contacthero/>
        <Contact/>
        <Footer/>

        </div>
    )
}

export default Contactpage